import useVersionsStore from '@/app/store/versions';

/**
 *
 */
function Versions() {

    const versions = useVersionsStore(state => state.versions);

    return (
        <>
            {
                versions.bomo && versions.back &&
                <div className='versions'>
                    v{versions.bomo}
                    -
                    {versions.back}
                </div>
            }
        </>
    );
}

/**
 *
 */
function VersionsCustomPay() {
    const versions = useVersionsStore(state => state.versions);

    return (
        <>
            {
                versions.customPay && versions.back &&
                <div className='versions'>
                    v{versions.customPay}
                    -
                    {versions.back}
                </div>
            }
        </>
    );
}

export default Versions;
export { VersionsCustomPay };